import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import twitterIcon from "@icons/twitter.svg";
import linkedin from "@icons/linkedin.svg";
import ArrowUpRight from "@assets/images/icons/ArrowUpRight.svg";
import footerIcon from "@icons/footer-icon.svg";
import { OPEN_EVENT } from "../CookieConsent/CookieConsent";
import NewsletterBar from "../NewsLetter/NewsletterBar";

const footerQuickLinks = [
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Features", href: "/#features" },
  { label: "Pricing", to: "/pricing-cards" },
  { label: "Contact", to: "/contact" },
];

function Footer() {
  const handleOpenCookiePreferences = () => {
    window.dispatchEvent(new Event(OPEN_EVENT));
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-head-section">
          <h2 className="footer-heading">Stop babysitting a dozen tools.<br />Hire Vienna instead.</h2>
          <p className="footer-subtext">
            Vienna is ready to start. Book a demo and see it run your stack.
          </p>
        </div>
        <Link
          to="/book-a-demo"
          className="footer-button-link footer-cta-combined"
          aria-label="Book a demo of Vienna"
        >
          <span className="button button--primary-new">Book a demo</span>
          <span className="button button--circle-primary" aria-hidden="true">
            <img src={ArrowUpRight} alt="" width="24" height="24" />
          </span>
        </Link>
      </div>

      <NewsletterBar />

      <div className="footer-bottom">
        <div className="footer-column">
          <h4>Products</h4>
          <ul>
            <li>
              <Link to="/startups-vc" className="nav-menu-item nav-link">
                Startups & VC
              </Link>
            </li>
            <li>
              <Link to="/civil" className="nav-menu-item nav-link">
                Demands & Civil Litigation
              </Link>
            </li>

            <li>
              <Link to="/criminal" className="nav-menu-item nav-link">
                Criminal Defense
              </Link>
            </li>
            <li>Family Law</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Resources</h4>
          <ul>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/blog">Blog</Link></li>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/faq">FAQ</Link></li>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/product-documentation">Product Documentation</Link></li>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/changelog">Changelog</Link></li>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/product-documentation/faq-structured-data">FAQ Structured Data</Link></li>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link style={{ textDecoration: "none", color: "white" }} to="/terms-of-service">Terms of Service</Link></li>
            <li className="footer-cookie-preferences">
              <button
                type="button"
                className="footer-text-button"
                onClick={handleOpenCookiePreferences}
              >
                Cookie Preferences
              </button>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            {footerQuickLinks.map((link) => (
              <li key={link.label}>
                {link.to ? (
                  <Link className="footer-link" to={link.to}>
                    {link.label}
                  </Link>
                ) : (
                  <a className="footer-link" href={link.href}>
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <h4>Stay Connected</h4>
          <ul className="social-icons" aria-label="Social links">
            <li>
              <a href="https://x.com/juristai" target="_blank" rel="noopener noreferrer" aria-label="Nougat on X">
                <img src={twitterIcon} className="twitter-icon" alt="" width="20" height="20" loading="lazy" decoding="async" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/juristai" target="_blank" rel="noopener noreferrer" aria-label="Nougat on LinkedIn">
                <img src={linkedin} alt="" width="20" height="20" loading="lazy" decoding="async" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-info">
        <div className="footer-brand">
          <Link to={"/"} aria-label="Nougat home">
            <img src={footerIcon} alt="" width="112" height="35" loading="lazy" decoding="async" />
          </Link>
        </div>
        <div className="">
          <p>
            Vienna, your legal operations hire. Legal intelligence,
            orchestrated.
          </p>

          <div className="copy-right-section">
            <p className="copyright">
              © 2026 Nougat Legal Technology Corporation Corporation.
            </p>
            <p>
              Vienna is legal software — not a law firm. It does not practice
              law, and nothing she outputs is legal advice. Vienna and her
              workspaces orchestrate legal work such as research, drafting support, and
              monitoring, with human-in-the-loop safety rails. Outputs are
              unfinished drafts and may be inaccurate, and deadline monitoring
              is informational: verify everything before you act or file. All
              legal decisions remain the user's responsibility. All rights
              reserved. Use is subject to Terms, Privacy, Legal, and Safety.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
